(function($) {

    /*
      This JS shows the sections only on click on one of the tabs.
      '.c-tablist__sections' is hidden by CSS into: `src/views/03-organisms/organism-tablist/_tablist.scss`
    */

    var $tabs     = $('.c-tablist--forms .c-tablist__tabs a');
    var $sections = $('.c-tablist--forms .c-tablist__sections');

  $tabs.click(function () {

    //**  non credo che serva più 
    //**  commento tutto per poi rimuoverlo */

      // Shows the sections on click
      // $sections.show();
    
      // Jumps the page to the offset of tabs only on mobile in order to avoid page jumping on every tap.
      // if ($(window).width() < 768) {
      //   $("html, body").animate({
      //     scrollTop: $(this).offset().top - 10
      //   }, 300);
      // };

    });

      
})(jQuery);